import { useTranslations } from 'src/provider/LocaleProvider'

export function HeaderLabels() {
    const t = useTranslations()
    const languageOptions = [
        { label: 'English', value: 'en' },
        { label: 'Español', value: 'es' },
        // { label: '普通话', value: 'zh' },
    ]
    const GrowOptions = [
        {
            label: `${t('buildProject.title')}`,
            value: 'en',
            navigate: 'buildToProject',
        },
        {
            label: `${t('cta.services')}`,
            value: 'es',
            navigate: 'services',
        },
    ]

    const navigateOptions = [
        { label: `${t('successStories.title')}`, navigation: 'successStories' },
        { label: `${t('cta.team')}`, navigation: 'team' },
        { label: `${t('cta.blog')}`, navigation: 'blog' },
        { label: `${t('cta.hiring')}`, navigation: 'wereHiring' },
    ]

    return { languageOptions, GrowOptions, navigateOptions }
}
